// @flow
import React, { useContext, useState } from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { truncate } from 'Components/utils/string/string.util';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import DynamicLink, {
  type Props as DynamicLinkProps,
} from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

import { themes } from './Tile.themes';

type TileProps = {
  catchline?: string,
  className?: string,
  color?: string,
  link?: DynamicLinkProps,
  maxLengthOfText?: number,
  text?: string,
  theme?: string,
  title: string,
  trackingData?: TrackingData,
};

export function Tile(props: TileProps) {
  const {
    catchline,
    className,
    color = COLORS.PRUNE,
    link = {},
    maxLengthOfText = 255,
    text = '',
    theme = 'default',
    title,
    trackingData,
  } = props;

  const { isBrowserGreaterThan } = useContext(ResponsiveContext);
  const [isExpand, setExpand] = useState(false);

  const { thBody, thCatchline, thLink, thRoot, thRootStyle, thText, thtitle } = themes[theme]({
    color,
    isExpand,
    isLarge: isBrowserGreaterThan.S,
  });

  const truncatedText = truncate(text, maxLengthOfText);

  // eslint-disable-next-line clubmed/no-fake-component
  const withLink = node => {
    return link.url ? (
      <TrackClick as={DynamicLink} trackingData={trackingData} className={thLink} {...link}>
        {node}
      </TrackClick>
    ) : (
      node
    );
  };

  return (
    <article
      className={classnames(className, thRoot)}
      style={thRootStyle}
      onBlur={() => setExpand(false)}
      onFocus={() => setExpand(true)}
      onMouseEnter={() => setExpand(true)}
      onMouseLeave={() => setExpand(false)}
    >
      {withLink(
        <div className={thBody}>
          <h2 className={thtitle}>{title}</h2>
          {!!catchline && <h3 className={thCatchline}>{catchline}</h3>}
          {!!truncatedText && <Text className={thText} text={truncatedText} theme="none" />}
        </div>,
      )}
    </article>
  );
}
